<div class="quiz-page">

    <h1 class="title">All Quizzes</h1>
    <p class="subtitle">View and manage quizzes across all classrooms</p>
    <div class="top-bar">
        <input type="text" class="search-input" placeholder="Search by Quiz Name" [(ngModel)]="searchText"
            (ngModelChange)="searchQuiz(searchText)" />
        <!-- Classroom Filter -->
        <ng-container>
            <!-- Select -->
            <div class="select-wrapper" *ngIf="selectedClassroom === 'all'">
                <select class="filter-select" [(ngModel)]="selectedClassroom" (change)="applyFilter()">
                    <option [ngValue]="'all'">All Classrooms</option>

                    <option *ngFor="let c of classrooms" [ngValue]="c.id">
                        {{ c.name }}
                    </option>
                </select>
                <i class="bi bi-chevron-down select-arrow"></i>
            </div>

            <div class="filter-chip" *ngIf="selectedClassroom !== 'all'">
                Classroom: <span>{{ getSelectedClassroomName() }}</span>
                <span class="close-icon" (click)="clearClassroom()">✕</span>
            </div>
        </ng-container>

        <ng-container>
            <!-- Select -->
            <div class="select-wrapper" *ngIf="selectedStatus === 'all'">
                <select class="filter-select" [(ngModel)]="selectedStatus" (change)="applyFilter()">
                    <option value="all">Status: All</option>
                    <option value="Published">Published</option>
                    <option value="Draft">Draft</option>
                </select>
                <i class="bi bi-chevron-down select-arrow"></i>
            </div>

            <div class="filter-chip" *ngIf="selectedStatus !== 'all'">
                Status: <span>{{ selectedStatus }}</span>
                <span class="close-icon" (click)="clearStatus()">✕</span>
            </div>
        </ng-container>
    </div>

    <div class="table-card">
        <table class="quiz-table">
            <thead>
                <tr>
                    <th>S.NO</th>
                    <th>Quiz Name</th>
                    <th>Classroom</th>
                    <th>Created Date</th>
                    <th>Status</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let q of quizzes; let i = index">
                    <td>{{ (page - 1) * limit + i + 1 }}</td>
                    <td class="quiz-name">{{ q.quiz_name }}</td>
                    <td>{{ q.classroom }}</td>
                    <td>{{ q.created_date | date: 'mediumDate' }}</td>
                    <td>
                        <span class="status-badge" [ngClass]="q.status === 'Published' ? 'published' : 'draft'">
                            {{ q.status }}
                        </span>
                    </td>
                    <td>
                        <button class="btn-add" (click)="goToQuizPage(q)">
                            View
                        </button>
                    </td>
                </tr>

                <tr *ngIf="quizzes.length === 0">
                    <td colspan="6">
                        <div class="empty-row">No quizzes found for selected filters</div>
                    </td>
                </tr>
            </tbody>
        </table>
        <p-paginator [rows]="limit" [totalRecords]="totalRecords" [rowsPerPageOptions]="[5, 10, 20, 30, 40, 50, 100]"
            (onPageChange)="onPageChange($event)">
        </p-paginator>
    </div>
</div>